import { PaymentsProvider } from 'constants/payments';
import { transformBundleDiscountsConfigurationDto } from './bundle-discount';
export const transformPaymentsConfigurationDto = _ref => {
  let {
    escrow_provider
  } = _ref;
  return {
    escrowProvider: escrow_provider || PaymentsProvider.None
  };
};
export const transformSystemConfigurationDto = _ref2 => {
  let {
    measurements,
    portal_flavour,
    url_prefix_items,
    transparency_law_translation_keys,
    urls,
    user_country,
    stripe_api_key,
    business_account_informational_links_visible,
    payments,
    newsletter_subscription_type,
    phone_number_prefix,
    multitier_bundle_discount_config,
    featured_collection_discounts,
    registration_real_name_required,
    portal,
    cookie_consent_version,
    websocket_url,
    number_of_images_per_item,
    crm,
    welcome_images
  } = _ref2;
  return {
    measurements,
    portalFlavour: portal_flavour,
    urlPrefixItems: url_prefix_items,
    transparencyLawKeys: {
      buyerRights: transparency_law_translation_keys.buyer_rights,
      professionalSeller: transparency_law_translation_keys.professional_seller
    },
    urls: {
      impressum: urls.impressum,
      buyerProtection: urls.buyer_protection,
      ourPlatform: urls.our_platform,
      relevancyDescription: urls.relevancy_description,
      feedbackDescription: urls.feedback_description,
      buyerRights: urls.buyer_rights,
      civilCode: urls.civil_code,
      lawOfObligations: urls.law_of_obligations,
      professionalSeller: urls.professional_seller,
      onlineComplaints: urls.online_complaints
    },
    userCountry: user_country,
    stripeApiKey: stripe_api_key,
    businessAccountInformationalLinksVisible: business_account_informational_links_visible,
    payments: transformPaymentsConfigurationDto(payments),
    newsletterSubscriptionType: newsletter_subscription_type,
    phoneNumberPrefix: phone_number_prefix,
    bundleDiscountsConfiguration: transformBundleDiscountsConfigurationDto(multitier_bundle_discount_config),
    featuredCollectionDiscounts: featured_collection_discounts,
    registrationRealNameRequired: registration_real_name_required,
    portal,
    cookieConsentVersion: cookie_consent_version,
    websocketUrl: websocket_url,
    numberOfImagesPerItem: number_of_images_per_item,
    crm: {
      brazeConfig: crm.braze_config && {
        sdkEndpoint: crm.braze_config.sdk_endpoint,
        sdkKey: crm.braze_config.sdk_key,
        apiKey: crm.braze_config.api_key,
        safariWebsitePushId: crm.braze_config.safari_push_id
      }
    },
    welcomeImages: {
      phone: welcome_images.web.phone,
      tabletsUp: welcome_images.web.tablets_up,
      wide: welcome_images.web.wide
    }
  };
};